import { useState } from 'react';
import { Icono } from './Icono';

interface PropsEstrellas {
  puntaje: number;
  cantidad?: number;
  tamano?: number;
}

export function Estrellas({ puntaje, cantidad, tamano = 13 }: PropsEstrellas) {
  return (
    <span className="estrellas" style={{ fontSize: tamano }}>
      <Icono nombre="star" tamano={tamano} relleno="currentColor" className="estrellas__icono" />
      <span>
        {puntaje.toLocaleString('es-AR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}
        <span className="solo-lectores"> de 5</span>
      </span>
      {cantidad !== undefined && <span className="estrellas__cantidad">· {cantidad} reseñas</span>}
    </span>
  );
}

const TEXTOS = ['', 'Muy malo', 'Malo', 'Regular', 'Bueno', 'Excelente'] as const;

interface PropsSelectorEstrellas {
  valor: number;
  alCambiar: (valor: number) => void;
  etiqueta?: string;
}

export function SelectorEstrellas({ valor, alCambiar, etiqueta = 'Puntaje' }: PropsSelectorEstrellas) {
  const [encima, setEncima] = useState(0);
  const mostrado = encima || valor;

  return (
    <div>
      <div
        className="selector-estrellas"
        role="radiogroup"
        aria-label={etiqueta}
        onMouseLeave={() => { setEncima(0); }}
      >
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={n === valor}
            aria-label={`${n} de 5: ${TEXTOS[n]}`}
            className={n <= mostrado ? 'selector-estrellas__estrella selector-estrellas__estrella--llena' : 'selector-estrellas__estrella'}
            onClick={() => { alCambiar(n); }}
            onMouseEnter={() => { setEncima(n); }}
          >
            <Icono nombre="star" tamano={32} relleno={n <= mostrado ? 'currentColor' : 'none'} />
          </button>
        ))}
      </div>
      <div className={mostrado ? 'selector-estrellas__texto selector-estrellas__texto--activo' : 'selector-estrellas__texto'}>
        {TEXTOS[mostrado]}
      </div>
    </div>
  );
}
